
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table2";
import CadastroEmpresaCopiarButton from "@/modules/GrupoEmpresa/components/CadastroEmpresaCopiarButton.vue";
import { cadastroEmpresaCopiaMixin } from "@/modules/GrupoEmpresa/mixins/cadastroEmpresaCopia";

export default {
  name: "app-tributacao",
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    CadastroEmpresaCopiarButton,
  },
  mixins: [cadastroEmpresaCopiaMixin],
  data() {
    return {
      fields: [
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: false,
          width: "80%",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar pela descrição",
          },
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "20%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  methods: {
    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a tributação " + data.descricao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/tributacao/delete", {
              id: data.id,
            });
            this.$refs.tributacao.refresh();
            this.$toast.success("Tributação excluída!");
          }
        });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
